import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon, ClockIcon, UsersIcon, ShieldCheckIcon, HeartIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
export function ImpactSection() {
  return <section className="py-24 md:py-32 bg-gray-100" data-id="element-219">
      <div className="max-w-7xl mx-auto px-6" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16 md:mb-20 max-w-3xl" data-id="element-221">
          <span className="text-steel-700 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-222">
            The Impact
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-slate-900 leading-tight" data-id="element-223">
            When open enrollment spikes, your brokerage doesn't skip a beat.
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-4 md:space-y-6" data-id="element-224">
          {/* Top row: stat card */}
          <div className="grid grid-cols-1 gap-4 md:gap-6" data-id="element-225">
            <motion.div variants={itemVariants} className="relative rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[220px] bg-slate-900 overflow-hidden" data-id="element-226">
              <div className="absolute top-0 right-0 w-48 h-48 bg-steel-500/10 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4 pointer-events-none" data-id="element-227" />
              <div className="relative z-10" data-id="element-228">
                <div className="flex items-baseline gap-1 mb-4" data-id="element-229">
                  <span className="text-6xl md:text-7xl font-heading font-bold tracking-tight text-gray-50" data-id="element-230">
                    9
                  </span>
                  <span className="text-3xl md:text-4xl font-heading font-semibold text-steel-300" data-id="element-231">
                    x
                  </span>
                </div>
                <div className="h-px w-12 opacity-20 bg-gray-50" data-id="element-232" />
              </div>
              <p className="text-lg leading-relaxed font-medium mt-8 text-gray-100/90 relative z-10" data-id="element-233">
                Faster turnaround. Our dedicated team saves you hours every
                week.
              </p>
            </motion.div>
          </div>

          {/* Bottom row: qualitative cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6" data-id="element-234">
            <motion.div variants={itemVariants} className="relative rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[220px] bg-gray-200" data-id="element-235">
              <div className="w-10 h-10 rounded-xl bg-slate-900/10 flex items-center justify-center mb-6" data-id="element-236">
                <UsersIcon className="w-5 h-5 text-slate-800" data-id="element-237" />
              </div>
              <p className="text-lg leading-relaxed font-medium text-slate-900" data-id="element-238">
                Handle OEP spikes without scrambling to hire temp staff.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="relative rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[220px] bg-slate-100" data-id="element-239">
              <div className="w-10 h-10 rounded-xl bg-slate-900/10 flex items-center justify-center mb-6" data-id="element-240">
                <ShieldCheckIcon className="w-5 h-5 text-slate-800" data-id="element-241" />
              </div>
              <p className="text-lg leading-relaxed font-medium text-slate-900" data-id="element-242">
                Consistent quality. Groups are securely and reliably set up on
                benefits, every single time.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="relative rounded-3xl p-8 md:p-10 flex flex-col justify-between min-h-[220px] bg-white border border-gray-200 shadow-sm" data-id="element-243">
              <div className="w-10 h-10 rounded-xl bg-gray-100 flex items-center justify-center mb-6" data-id="element-244">
                <HeartIcon className="w-5 h-5 text-slate-800" data-id="element-245" />
              </div>
              <p className="text-lg leading-relaxed font-medium text-slate-900" data-id="element-246">
                Your team focuses on customer relationships instead of tedious
                data entry.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}